export default function() {
  const widgetName = 'sponsorWidgetContainer';
  const widgetOpts = sponsorWidgetOpts;

  return saffire.widgets.sponsors($(`#${widgetName}`), {
    scriptPath:  widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    timePerSponsor: 2,
    bw: false,
    rotate: true
  });
}
$(document).ready(function () {
  setTimeout(function() {
    $('.homepageh1').each(function() {
      $(this).replaceWith($('<h2 class="homepageh1">' + this.innerHTML + '</h2>'));
    });
  }, 3000);
});